import JobFeeSource from '@/models/Jobs/JobFeeSource';
import JobType from '@/models/Jobs/JobType';

export default class CreateJobRequest {
    ownerId: string;
    branchId: string;
    deskId: string;
    companyId: string;
    locationId: string;
    departmentId: string;
    contactId: string;
    primaryPositionId: string;
    title: string;
    headcount = 1;
    type: JobType = JobType.Permanent;
    closingDate: string;
    desiredStartDate: string;
    annualSalaryMin = 0;
    annualSalaryMax = 0;
    feeSource: JobFeeSource = JobFeeSource.RateCard;
    //feePercentage: number = 0;
    //feeFlat: number = 0;
    purchaseOrderNumber = '';
    isTest = false;
    testEmailAddresses = '';
    secondaryPositionIds: string[] = [];
    primarySkillIds: string[] = [];
    secondarySkillIds: string[] = [];
    primaryQualificationIds: string[] = [];
    secondaryQualificationIds: string[] = [];
}